import { Round } from ".";

export function getGridRowHeight(numRows: number, margin: number, totalHeight: number): number {
    const totalGridItemHeight = totalHeight - ((numRows + 1) * margin);

    return Round(totalGridItemHeight / numRows, 0);
}
